<template>
  <div class="registry-box">
    <table border="0" cellpadding="0" cellspacing="0" width="100%">
      <tbody>
        <tr>
          <td width="100%" align="center" valign="top" height="180"></td>
        </tr>
        <tr>
          <td align="center" style="padding: 0px 16px" class="section-padding">
            <table
              bgcolor="#ffffff"
              border="0"
              cellpadding="0"
              cellspacing="0"
              width="100%"
              style="max-width: 600px"
              class="responsive-table"
            >
              <tbody>
                <tr>
                  <td>
                    <table
                      width="100%"
                      border="0"
                      cellspacing="0"
                      cellpadding="0"
                    >
                      <tbody>
                        <tr>
                          <td
                            align="center"
                            style="padding: 40px 40px 0px 40px"
                          >
                            <img
                              src="https://coveyweb.s3.amazonaws.com/img/1649300219737-logo.25bd63bd.png"
                              width="70"
                              border="0"
                              style="vertical-align: middle"
                            />
                          </td>
                        </tr>
                        <tr>
                          <td
                            align="center"
                            style="
                              font-size: 18px;
                              color: #0e0e0f;
                              font-weight: 700;
                              font-family: Helvetica Neue;
                              line-height: 28px;
                              vertical-align: top;
                              text-align: center;
                              padding: 35px 40px 0px 40px;
                            "
                          >
                            <strong v-if="activateRes.status === '0'"
                              >Email activated.</strong
                            >
                            <strong v-else-if="activateRes.status === '400'"
                              >Email activation failed.</strong
                            >
                            <strong v-else
                              >Please click to enter the current link from the
                              mailbox.</strong
                            >
                          </td>
                        </tr>

                        <tr>
                          <td
                            align="center"
                            bgcolor="#ffffff"
                            height="1"
                            style="padding: 40px 16px 5px 16px"
                            valign="top"
                            width="100%"
                          >
                            <table cellpadding="0" cellspacing="0" width="100%">
                              <tbody>
                                <tr>
                                  <td
                                    style="border-top: 1px solid #e4e4e4"
                                  ></td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td
                            class="content"
                            style="
                              font: 16px/22px 'Helvetica Neue', Arial,
                                'sans-serif';
                              text-align: left;
                              color: #555555;
                              padding: 40px 40px 0 40px;
                            "
                          >
                            <p v-if="activateRes.status === '0'">
                              Now you can go to the login page to visit the
                              website!
                            </p>
                            <p v-else-if="activateRes.status === '400'">
                              {{ activateRes.message }}
                            </p>
                            <p v-else>
                              If there is a problem, please try again later!
                            </p>
                          </td>
                        </tr>
                        <tr>
                          <td>
                            <table
                              width="100%"
                              border="0"
                              cellspacing="0"
                              cellpadding="0"
                              style="margin: 30px 0px"
                            >
                              <tbody>
                                <tr>
                                  <td
                                    align="center"
                                    style="text-align: center"
                                    v-if="activateRes.status === '0'"
                                  >
                                    <a
                                      name="CTA"
                                      bgcolor="#1dbf73"
                                      style="
                                        color: #ffffff;
                                        background-color: #f48c06;
                                        display: inline-block;
                                        font-family: Helvetica Neue;
                                        font-size: 16px;
                                        line-height: 30px;
                                        text-align: center;
                                        font-weight: bold;
                                        text-decoration: none;
                                        padding: 5px 20px;
                                        -webkit-border-radius: 3px;
                                        -moz-border-radius: 3px;
                                        border-radius: 3px;
                                        text-transform: none;
                                      "
                                      href="/"
                                      target="_blank"
                                      rel="noopener"
                                      >To Log in
                                    </a>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </td>
                        </tr>

                        <tr>
                          <td
                            class="content"
                            style="
                              font: 16px/22px 'Helvetica Neue', Arial,
                                'sans-serif';
                              text-align: left;
                              color: #555555;
                              padding: 0 0 0 40px;
                            "
                          >
                            <p>Thanks, <br />The Covey Team</p>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </td>
                </tr>

                <tr>
                  <td
                    width="100%"
                    align="center"
                    valign="top"
                    bgcolor="#ffffff"
                    height="45"
                  ></td>
                </tr>
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td align="center" style="padding: 20px 0px"></td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  components: {},
  computed: {},
  data() {
    return {
      activateRes: {},
    };
  },
  created() {
    this.activateRes = this.$route.query;
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
@import "~@/utils/vw.scss";
.registry-box {
  height: 100vh;
  background: #fce9d1 !important;
  .qmbox style,
  .qmbox script,
  .qmbox head,
  .qmbox link,
  .qmbox meta {
    display: none !important;
  }
  .qmbox .ReadMsgBody {
    width: 100%;
    background-color: #ffffff;
  }

  .qmbox .ExternalClass {
    width: 100%;
    background-color: #ffffff;
  }

  .qmbox body {
    width: 100%;
    min-height: 100vh;
    // background-color: #e5e5e5;
    background: #fce9d1 !important;
    margin: 0;
    padding: 0;
    -webkit-font-smoothing: antialiased;
    font-family: Helvetica Light, Helvetica, Arial, sans-serif;
    -webkit-text-size-adjust: none !important;
  }

  .qmbox table {
    border-collapse: separate;
  }

  /* MOBILE STYLES */

  @media screen and (max-width: 780px) {
    /* ALLOWS FOR FLUID TABLES */
    .qmbox .wrapper {
      width: 100% !important;
      max-width: 100% !important;
    }

    /* ADJUSTS LAYOUT OF LOGO IMAGE */
    .qmbox .logo img {
      margin: 0 auto !important;
    }

    /* USE THESE CLASSES TO HIDE CONTENT ON MOBILE */
    .qmbox .mobile-hide {
      display: none !important;
    }

    .qmbox .img-max {
      max-width: 100% !important;
      width: 100% !important;
      height: auto !important;
    }

    /* FULL-WIDTH TABLES */
    .qmbox .responsive-table {
      width: 100% !important;
    }

    /* UTILITY CLASSES FOR ADJUSTING PADDING ON MOBILE */
    .qmbox .padding {
      padding: 0px 5% 0px 5% !important;
    }

    .qmbox .padding-meta {
      padding: 30px 5% 0px 5% !important;
      text-align: center;
    }

    .qmbox .no-padding {
      padding: 0 !important;
    }

    .qmbox .section-padding {
      padding: 0px 15px 0px 15px !important;
    }

    /* ADJUST BUTTONS ON MOBILE */
    .qmbox .mobile-button-container {
      margin: 0 auto;
      width: 100% !important;
    }

    .qmbox .mobile-button {
      padding: 15px !important;
      border: 0 !important;
      font-size: 16px !important;
      display: block !important;
    }
  }

  .qmbox table,
  .qmbox td,
  .qmbox b,
  .qmbox a,
  .qmbox strong,
  .qmbox p,
  .qmbox div {
    font-family: "Helvetica Neue", Arial, "sans-serif";
  }

  .qmbox td.content {
    font: 16px/22px "Helvetica Neue", Arial, "sans-serif";
    text-align: left;
    padding: 50px 40px 0px 40px;
    color: #555555;
  }

  .qmbox a {
    color: #1dbf73;
    text-decoration: none;
  }

  /* ANDROID CENTER FIX */

  .qmbox div[style*="margin: 16px 0;"] {
    margin: 0 !important;
  }

  .qmbox a.fiverr-social-icon {
    display: inline-block;
    margin: 2px 5px;
  }
}
</style>